export default function AboutNoteSection() {
  return (
    <section className="bg-background-50 py-20 md:py-28">
      <div className="w-full px-4 md:px-8 lg:px-12 max-w-2xl mx-auto text-center">
        {/* Decorative line above */}
        <div className="w-20 h-px bg-accent-500/60 mx-auto mb-10" />

        {/* Handwritten note */}
        <p
          className="font-hand text-xl md:text-2xl lg:text-3xl text-[#6B1E3B] leading-snug"
        >
          you are the home you've been looking for,
          <br />
          it's time to return there
        </p>

        {/* Signature */}
        <p className="font-hand text-base md:text-lg text-accent-600 mt-8">
          — Mandie
        </p>

        {/* Decorative line below */}
        <div className="w-20 h-px bg-accent-500/60 mx-auto mt-10" />
      </div>
    </section>
  );
}